import { render, staticRenderFns } from "./ImportAnnexData.vue?vue&type=template&id=e924b77e&scoped=true&"
import script from "./ImportAnnexData.vue?vue&type=script&lang=js&"
export * from "./ImportAnnexData.vue?vue&type=script&lang=js&"
import style0 from "./ImportAnnexData.vue?vue&type=style&index=0&id=e924b77e&prod&scoped=true&lang=css&"
import style1 from "./ImportAnnexData.vue?vue&type=style&index=1&id=e924b77e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e924b77e",
  null
  
)

export default component.exports